module.exports = __webpack_public_path__ + "static/media/aboutMe.b85b9415.jpg";